<template>
  <CanvasJSChart :options="options" :styles="styleOptions"/>
</template>     

<script>
import * as CanvasJS from '@canvasjs/charts';

export default {
  data() {
    return {
      options: {
        theme: "light2",
        animationEnabled: true,
        exportEnabled: true,
        axisY: {
          title: "",
          minimum: 0, // Start Y-axis from 0

          interval: 200, // Set the interval between ticks
          maximum: 1000, // Set the maximum value
          labelFormatter: function (e) {
            return e.value; // Display values as is
          }
        },
        toolTip: {
          shared: true,
          contentFormatter: function (e) {
            return (
              "<span style='color:" +
              e.entries[0].dataSeries.color +
              ";'>" +
              e.entries[0].dataPoint.label +
              "</span>: " +
              CanvasJS.formatNumber(
                e.entries[0].dataPoint.y / 1,
                "#.#0"
              ) +
              "T KilowattHour"
            );
          }
        },
        data: [
          {
            type: "splineArea",
            color: "#7986CB",
            dataPoints: [
              { label: "Jan", y: 530 },
              { label: "Feb", y: 520 },
              { label: "Mar", y: 520 },
              { label: "April", y: 520 },
              { label: "May", y: 650 },
              { label: "June", y: 680 },
              { label: "July", y: 650 },
              { label: "Aug", y: 650 },
              { label: "Sep", y: 750 },
              { label: "Oct", y: 750 },
              { label: "Nov", y: 750 },
              { label: "Dec", y: 800 }
            ]
          }
        ]
      },
      styleOptions: {
        width: "100%",
        height: "360px"
      }
    };
  }
};
</script>

<style>
.canvasjs-chart-toolbar {
    display: none !important;
  }
</style>
